import React from "react";

import { useFormikContext } from "formik";

import ChatGPTSVG from "../../../../../assets/svg/chatgpt.svg";
import GeminiSVG from "../../../../../assets/svg/gemini.svg";
import RecraftSVG from "../../../../../assets/svg/recraft.svg";
import { ImageEngineEnum } from "../../../../../enums/imageEngine";
import { Template } from "../../../../../models";

import EnginePrimaryNote from "../../../../../components/common/EnginePrimaryNote";
import CustomSelect, {
  OptionType,
} from "../../../../../components/form/CustomSelect";
import TemplateContainer from "../../common/TemplateContainer";

const imageEngineOptions: OptionType[] = [
  {
    value: ImageEngineEnum.GPT_IMAGE_2,
    label: "GPT Image 2",
    description: "",
    icon: ChatGPTSVG,
  },
  {
    value: ImageEngineEnum.RECRAFT_V3,
    label: "Recraft V3",
    description: "",
    icon: RecraftSVG,
  },
  {
    value: ImageEngineEnum.GEMINI_2_5_FLASH_IMAGE,
    label: "Gemini 2.5 Flash Image",
    description: "",
    icon: GeminiSVG,
  },
];

export default function ImageEngineSelector() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();
  const selectedEngine = imageEngineOptions.find(
    (option) => option.value === values?.imageEngineId
  );

  return (
    <TemplateContainer
      isSuperUserFeature
      className="space-y-4"
    >
      <CustomSelect
        label="Image Engine"
        placeholder="-"
        options={imageEngineOptions}
        selected={selectedEngine}
        setSelected={(option) => {
          setFieldValue(
            "imageEngineId",
            (option?.value as ImageEngineEnum) || null
          );
          if (option?.value === ImageEngineEnum.RECRAFT_V3) {
            setFieldValue("excludeImageText", true);
            setFieldValue("excludeImageFaces", true);
          } else {
            setFieldValue("excludeImageText", null);
            setFieldValue("excludeImageFaces", null);
          }
        }}
      />
      {!selectedEngine && (
        <EnginePrimaryNote
          engineName="Recraft"
          icon={RecraftSVG}
        />
      )}
    </TemplateContainer>
  );
}
